export const Types = {
  SET_DATA: 'company/SET_DATA',
}

const INITIAL_STATE = {}

export default function company(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.SET_DATA:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export const Creators = {
  setCompanyData: data => ({ type: Types.SET_DATA, payload: data }),
}
